import { IonToast } from '@ionic/react'
import { useRegisterSW } from 'virtual:pwa-register/react'

/**
 * A new version, offered rather than applied.
 *
 * The service worker is registered with `registerType: 'prompt'` on purpose. An
 * automatic `skipWaiting` swap reloads the page under whoever is using it, and
 * on this surface that means losing the session id mid-booking — the flow state
 * itself is server-side, but the id that reaches it lives only in memory here,
 * so a reload at the wrong moment throws away a half-filled form.
 *
 * So the update waits for a tap. A customer who ignores it gets the new version
 * next time they open the app, which is soon enough for a booking screen.
 *
 * Native builds never see this: an installed app updates through the store, and
 * `useRegisterSW` finds no service worker to register inside a Capacitor
 * WebView.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  return (
    <IonToast
      cssClass="blooq-toast"
      isOpen={needRefresh}
      message="A new version is ready."
      position="bottom"
      buttons={[
        {
          text: 'Reload',
          handler: () => {
            void updateServiceWorker(true)
          },
        },
        { text: 'Later', role: 'cancel' },
      ]}
      onDidDismiss={() => setNeedRefresh(false)}
    />
  )
}
